<div class="page-places-component mat-typography" fxLayout="column" fxLayoutGap="14px">

    <table mat-table [dataSource]="dataSource" multiTemplateDataRows class="mat-elevation-z8 data-table">
        
        <ng-container matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef> title </th>
            <td mat-cell *matCellDef="let element"> {{element.title}} </td>
        </ng-container>

        <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef> description </th>
            <td mat-cell *matCellDef="let element"> {{element.description}} </td>
        </ng-container>

        <ng-container matColumnDef="shorthandSymbol">
            <th mat-header-cell *matHeaderCellDef> shorthandSymbol </th>
            <td mat-cell *matCellDef="let element"> {{element.shorthandSymbol}} </td>
        </ng-container>

        <ng-container matColumnDef="address">
            <th mat-header-cell *matHeaderCellDef> address </th>
            <td mat-cell *matCellDef="let element"> {{element.address}} </td>
        </ng-container>

        <ng-container matColumnDef="delete">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element" class="action-column">
                <button mat-icon-button (click)="$event.stopPropagation(); delete(element);">
                    <mat-icon>delete</mat-icon>
                </button>
            </td>
        </ng-container>

        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
        <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                <div class="element-detail"
                    [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                    <app-table-detail-abstract [data]="element"></app-table-detail-abstract>
                </div>
            </td>
        </ng-container>

        <tr mat-header-row @rowAnimation *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row @rowAnimation *matRowDef="let element; columns: displayedColumns;" class="element-row"
            [class.expanded-row]="expandedElement === element"
            (click)="expandedElement = expandedElement === element ? null : element" (press)="openPlace(element)"></tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
    </table>

    <div class="add-button">
        <button mat-mini-fab (click)="add()" matTooltip="add place">
            <mat-icon>add</mat-icon>
        </button>
    </div>

</div>